/**
 * AreaMapDirection enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file AreaMapDirection.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum AreaMapDirection {
  NORTH = 0,
  SOUTH = 1,
  EAST  = 2,
  WEST  = 3
};